import LocalStorageHelpers from '@application/helpers/local-storage-helpers';
export const attachRequestInterceptor = (api) => {
    api.interceptors.request.use(async (config) => {
        const token = LocalStorageHelpers.getAccessToken();
        if (token && config.url !== 'account/authenticate') {
            if (config.headers) {
                config.headers.set('Authorization', `Bearer ${token}`);
            }
        }
        return config;
    });
    return api;
};
